export const RecommendationPropertyDefaultDistance = 5000;
export const RecommendationPropertyDefaultDistance = 5000;
